import React from 'react'
import { DashboardSummary } from '../../../lib/types/propsType_v1'
import { centsToCurrency, signedClass, signedPercent } from '../dashboard-v2.utils'

type StatsProps = {
  summary: DashboardSummary
}

export const Stats: React.FC<StatsProps> = ({ summary }) => {
  const signedAmountText = (value?: number) => {
    if (typeof value !== 'number' || Number.isNaN(value)) return '$0'
    const absText = centsToCurrency(Math.abs(value))
    if (value > 0) return `+${absText}`
    if (value < 0) return `-${absText}`
    return absText
  }

  return (
    <div className='dashboard-v2__stats-grid'>
      <article className='dashboard-v2__stat-card'>
        <div className='icon'>💵</div>
        <p>Total Amount Invested</p>
        <h3 className='value-fit'>{centsToCurrency(summary?.totalInvestedAmount)}</h3>
      </article>
      <article className='dashboard-v2__stat-card'>
        <div className='icon'>💰</div>
        <p>Total Returns</p>
        <h3 className='value-fit'>{centsToCurrency(summary?.totalReturnsTillDate)}</h3>
      </article>
      <article className='dashboard-v2__stat-card'>
        <div className='icon'>🏅</div>
        <p>Realized Gains/Losses</p>
        <h3 className='value-fit'>{signedAmountText(summary?.realizedGainsAmount)}</h3>
        <p className={`stat-subscript ${signedClass(summary?.realizedGains)}`}>
          {signedPercent(summary?.realizedGains)}
        </p>
      </article>
      <article className='dashboard-v2__stat-card'>
        <div className='icon'>📈</div>
        <p>Unrealized Gains/Losses</p>
        <h3 className='value-fit'>{signedAmountText(summary?.unrealizedGainsAmount)}</h3>
        <p className={`stat-subscript ${signedClass(summary?.unrealizedGains)}`}>
          {signedPercent(summary?.unrealizedGains)}
        </p>
      </article>
    </div>
  )
}
